
import { useState } from "react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";

interface FortuneFormProps {
  onFortuneCreated: (fortune: string) => void;
}

const FortuneForm = ({ onFortuneCreated }: FortuneFormProps) => {
  const [customFortune, setCustomFortune] = useState("");
  const [authorName, setAuthorName] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!customFortune.trim()) {
      toast.error("Please enter a fortune message");
      return;
    }

    // Store the generated fortune with optional author attribution
    const fortune = authorName 
      ? `${customFortune} - ${authorName}` 
      : customFortune;
    
    onFortuneCreated(fortune);
    toast.success("Your custom fortune has been created!");
  };

  return (
    <div className="bg-card rounded-xl p-6 md:p-8 shadow-md border">
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="space-y-2">
          <Label htmlFor="fortuneText">Your Fortune Message</Label>
          <Textarea 
            id="fortuneText"
            placeholder="Enter your fortune message here..."
            className="min-h-[120px]"
            value={customFortune}
            onChange={(e) => setCustomFortune(e.target.value)}
            maxLength={200}
          />
          <p className="text-xs text-muted-foreground text-right">
            {customFortune.length}/200 characters
          </p>
        </div>

        <div className="space-y-2">
          <Label htmlFor="author">Your Name (Optional)</Label>
          <Input 
            id="author" 
            placeholder="Author of this fortune (optional)"
            value={authorName}
            onChange={(e) => setAuthorName(e.target.value)}
          />
        </div>

        <div className="pt-4">
          <Button type="submit" className="w-full bg-cookie-dark hover:bg-cookie-light">
            Create My Fortune
          </Button>
        </div>
      </form>
    </div>
  );
};

export default FortuneForm;
